import axios from 'axios';

const client = axios.create({
  baseURL: '/api',
  withCredentials: true,
  // Send Django's CSRF cookie back as a header on every request.
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
});

client.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response.status === 401 || error.response.status === 403) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default client;
